import * as React from "react";
import type { SVGProps } from "react";
const SvgSmallMilestone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 9.469c-2.329.32-4 1.181-4 2.196C2 12.955 4.686 14 8 14s6-1.045 6-2.334c0-1.015-1.671-1.876-4-2.196M8 11.335V2.668"
    />
    <rect
      width={6}
      height={4.667}
      x={8}
      y={2}
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      rx={1}
    />
  </svg>
);
export default SvgSmallMilestone;
